import { useNavigate } from "react-router-dom";
import { scrollToForm } from "../../utils/scrolls";
import Badge from "../badge";
import Header from "../header";
import MyButton from "../myButton";
import MyForm from "../myForm";
import "./styles.scss";
import EnergySavingsLeafTwoToneIcon from "@mui/icons-material/EnergySavingsLeafTwoTone";
import WestIcon from "@mui/icons-material/West";
import { useEffect, useRef, useState } from "react";

export default function HomeIntro() {
	const navigate = useNavigate();
	const ref = useRef<HTMLDivElement | null>(null);
	const headerRef = useRef<HTMLElement | null>(null);
	const [stickyTop, setStickyTop] = useState(-540);

	useEffect(() => {
		if (!ref.current || !headerRef.current) return;

		let timeout: ReturnType<typeof setTimeout> | undefined;

		const calculate = () => {
			if (timeout) {
				clearTimeout(timeout);
			}

			timeout = setTimeout(() => {
				const container = ref.current;
				const header = headerRef.current;

				if (!container || !header) return;

				const totalHeight = container.offsetHeight;
				const headerHeight = header.offsetHeight;

				setStickyTop(-(totalHeight - headerHeight - 10));
			}, 50);
		};

		const observer = new ResizeObserver(calculate);
		observer.observe(ref.current);
		observer.observe(headerRef.current);

		window.visualViewport?.addEventListener("resize", calculate);

		calculate();

		return () => {
			if (timeout) {
				clearTimeout(timeout);
			}

			observer.disconnect();
			window.visualViewport?.removeEventListener("resize", calculate);
		};
	}, []);

	return (
		<div ref={ref} className="home-intro" style={{ top: `${stickyTop}px` }}>
			<div className="home-intro-content">
				<Header ref={headerRef} />
				<div className="home-intro-body">
					<div className="left">
						<div className="form-wrapper">
							<MyForm />
						</div>
					</div>
					<div className="right">
						<Badge text="دعم سريع لإعداد الشكاوى" icon={<EnergySavingsLeafTwoToneIcon />} />
						<div className="home-intro-title-container">
							<div className="home-intro-title-wrapper">
								<p className="home-intro-title">جهّز شكواك</p>
								<p className="home-intro-title primary">بسهولة وبمتابعة مخصصة</p>
								<p className="home-intro-title">في سلطنة عُمان</p>
							</div>
							<p className="home-intro-subtitle">
								نساعدك في ترتيب بيانات الشكوى وصياغتها بوضوح كخدمة فردية مستقلة، ثم نتواصل معك لمراجعة التفاصيل والخطوات العامة وفق المعلومات التي تزودنا بها.
							</p>
						</div>
						<div className="home-intro-action-btns">
							<MyButton className="intro-start-now-btn" onClick={() => scrollToForm(navigate, "#form-card")}>
								اطلب المساعدة الآن
								<WestIcon className="intro-start-now-btn-icon" />
							</MyButton>
							<p className="home-intro-disclaimer">خدمة فردية مستقلة وليست بوابة حكومية أو مكتب محاماة أو خدمة استشارات قانونية مرخصة.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
